/** CoStar.Api.Search.Criteria.GeographyFilterType */
export var GeographyFilterType;
(function (GeographyFilterType) {
    GeographyFilterType[GeographyFilterType["Unknown"] = 0] = "Unknown";
    GeographyFilterType[GeographyFilterType["PostalCode"] = 2] = "PostalCode";
    GeographyFilterType[GeographyFilterType["City"] = 3] = "City";
    GeographyFilterType[GeographyFilterType["Submarket"] = 5] = "Submarket";
    GeographyFilterType[GeographyFilterType["Street"] = 6] = "Street";
    GeographyFilterType[GeographyFilterType["ResearchMarket"] = 7] = "ResearchMarket";
    GeographyFilterType[GeographyFilterType["County"] = 10] = "County";
    GeographyFilterType[GeographyFilterType["Subdivision"] = 11] = "Subdivision";
    GeographyFilterType[GeographyFilterType["ShoppingCenter"] = 14] = "ShoppingCenter";
    GeographyFilterType[GeographyFilterType["Country"] = 15] = "Country";
    GeographyFilterType[GeographyFilterType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    GeographyFilterType[GeographyFilterType["Region"] = 17] = "Region";
    GeographyFilterType[GeographyFilterType["CBSA"] = 18] = "CBSA";
    GeographyFilterType[GeographyFilterType["CSA"] = 19] = "CSA";
    GeographyFilterType[GeographyFilterType["DMA"] = 20] = "DMA";
    GeographyFilterType[GeographyFilterType["Cluster"] = 21] = "Cluster";
    GeographyFilterType[GeographyFilterType["Airport"] = 22] = "Airport";
    GeographyFilterType[GeographyFilterType["HotelName"] = 23] = "HotelName";
    GeographyFilterType[GeographyFilterType["TransitStation"] = 24] = "TransitStation";
    GeographyFilterType[GeographyFilterType["Military"] = 25] = "Military";
    GeographyFilterType[GeographyFilterType["University"] = 26] = "University";
    GeographyFilterType[GeographyFilterType["SchoolWithAttendanceZone"] = 37] = "SchoolWithAttendanceZone";
    GeographyFilterType[GeographyFilterType["SchoolWithNoAttendanceZone"] = 38] = "SchoolWithNoAttendanceZone";
    GeographyFilterType[GeographyFilterType["SchoolDistrict"] = 39] = "SchoolDistrict";
    GeographyFilterType[GeographyFilterType["CityAggregate"] = 40] = "CityAggregate";
    GeographyFilterType[GeographyFilterType["CoStarMarket"] = 132] = "CoStarMarket";
    GeographyFilterType[GeographyFilterType["PostalCodeGlobal"] = 142] = "PostalCodeGlobal";
})(GeographyFilterType || (GeographyFilterType = {}));
/** CoStar.Api.Search.Criteria.ContiguousSpaceType */
export var ContiguousSpaceType;
(function (ContiguousSpaceType) {
    ContiguousSpaceType[ContiguousSpaceType["None"] = 0] = "None";
    ContiguousSpaceType[ContiguousSpaceType["ContiguousInBuilding"] = 1] = "ContiguousInBuilding";
    ContiguousSpaceType[ContiguousSpaceType["ContiguousOnOneFloor"] = 2] = "ContiguousOnOneFloor";
    ContiguousSpaceType[ContiguousSpaceType["InOneSuite"] = 3] = "InOneSuite";
    ContiguousSpaceType[ContiguousSpaceType["TotalInBuilding"] = 4] = "TotalInBuilding";
    ContiguousSpaceType[ContiguousSpaceType["TotalInListing"] = 5] = "TotalInListing";
    ContiguousSpaceType[ContiguousSpaceType["InOneBuilding"] = 6] = "InOneBuilding";
})(ContiguousSpaceType || (ContiguousSpaceType = {}));
